import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Col, Row, message, Select } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";

function AddUser(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord, edit } = props;
  const [response, request] = useApi("/config/user", null, API_METHODS.POST);
  const [editResponse, editRequest] = useApi(
    `/config/user/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );

  const [rolesResponse, rolesRequest] = useApi(
    "/common/roles",
    null,
    API_METHODS.GET
  );

  const [roles, setRoles] = useState([]);

  useEffect(() => {
    rolesRequest();
  }, []);

  useEffect(() => {
    const data = rolesResponse.data !== BLANK_VALUE ? rolesResponse.data : [];
    setRoles(data);
  }, [rolesResponse]);

  useEffect(() => {
    if (response.data) {
      close(true);
      message.success("User added successfully.");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("User updated successfully.");
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        } else {
          request(values, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  return (
    <>
      <Modal
        title={selectedRecord ? "Update User" : "Add User"}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        okText="Save"
      >
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col lg={8} md={12} sm={24} xs={24}>
              <Form.Item
                name="username"
                label="Username"
                rules={[
                  { required: true, message: "Username is required." },
                  {
                    max: 25,
                    message: "Username should be maximum of 25 characters.",
                  },
                ]}
              >
                <Input placeholder="Username" />
              </Form.Item>
            </Col>
            <Col lg={8} md={12} sm={24} xs={24}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "email is required." },
                  {
                    max: 200,
                    message: "email should be maximum of 200 characters.",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
            </Col>
            <Col lg={8} md={12} sm={24} xs={24}>
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  { required: true, message: "name is required." },
                  {
                    max: 100,
                    message: "Name should be maximum of 100 characters.",
                  },
                ]}
              >
                <Input placeholder="Username" />
              </Form.Item>
            </Col>

            {!edit && (
              <Col lg={8} md={12} sm={24} xs={24}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    { required: true, message: "Password is required." },
                    {
                      max: 20,
                      message: "Password should be maximum of 20 characters.",
                    },
                  ]}
                >
                  <Input placeholder="Password" />
                </Form.Item>
              </Col>
            )}
            <Col lg={8} md={12} sm={24} xs={24}>
              <Form.Item
                name="role_id"
                label="Role"
                rules={[{ required: true, message: "Role is required." }]}
              >
                <Select
                  placeholder="Select Role"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {roles?.length > 0 &&
                    roles.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.role}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default AddUser;
